import { FreebieModel } from "@gtpl/shared-models/canteen-management";
import { Injectable } from "@nestjs/common";
import { FreebieRequest } from "./dto/freebie.dto";
import { FreebieEntity } from "./entity/freebie.entity";


@Injectable()
export class FreebiesAdapter {

    /**
     * 
     * @param companyId 
     * @param departmentId 
     * @param category 
     * @param description 
     * @param username 
     * @param startHour 
     * @param endHour 
     * @returns 
     */

    convertDtoToFreebieEntity(freebiesReq: FreebieRequest): FreebieEntity {

        const freebieEntity = new FreebieEntity();
        freebieEntity.freebieId = freebiesReq.freebieId;
        freebieEntity.companyId = freebiesReq.companyId;
        freebieEntity.departmentId = freebiesReq.departmentId;
        freebieEntity.freebieCode = freebiesReq.freebieCode;
        freebieEntity.category = freebiesReq.freebieCategory;
        freebieEntity.description = freebiesReq.description;
        freebieEntity.startHour = freebiesReq.startHour;
        freebieEntity.startMinutes = freebiesReq.startMinutes;
        freebieEntity.endHour = freebiesReq.endHour;
        freebieEntity.endMinutes = freebiesReq.endMinutes;
        freebieEntity.createdUser = freebiesReq.createdUser;
        freebieEntity.unitPrice = freebiesReq.unitPrice;
        freebieEntity.versionFlag=freebiesReq.versionFlag;
        // freebieEntity.startTime = freebiesReq.startTime;
        // freebieEntity.endTime = freebiesReq.endTime;
        return freebieEntity;
    }

    /**
     * returns the freebie model for the given freebie entity 
     * @param freebieEntity 
     * @returns 
     */
    convertFreebieEntityToDto(freebieEntity: FreebieEntity): FreebieModel {
        return new FreebieModel(
                freebieEntity.freebieId,
                freebieEntity.category,
                freebieEntity.unitPrice,
                freebieEntity.description,
                freebieEntity.companyId,
                freebieEntity.departmentId,
                freebieEntity.freebieCode,
                freebieEntity.startHour,
                freebieEntity.startMinutes,
                freebieEntity.endHour,
                freebieEntity.endMinutes,
                freebieEntity.jobHour,
                freebieEntity.isActive,
                // freebieEntity.startTime,
                // freebieEntity.endTime
                
                
            
                freebieEntity.createdUser
        );
    }
}

